var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "job-preview-content-outline",
    _vm._g(
      { attrs: { title: "問い合わせ", "data-test": "inquiry" } },
      _vm.$listeners
    ),
    [
      _c(
        "job-preview-content",
        _vm._g(
          {
            attrs: {
              "comment-highlights": _vm.commentHighlights,
              "text-count-mode": _vm.textCountMode,
              "highlight-mode": _vm.highlightMode,
              "text-counts": _vm.textCounts,
            },
            scopedSlots: _vm._u([
              {
                key: "body",
                fn: function () {
                  return [
                    _c(
                      "p",
                      { staticClass: "clearfix" },
                      [
                        _c("span", {
                          attrs: { "data-test": "company-name" },
                          domProps: {
                            innerHTML: _vm._s(_vm.companyName + "<br>"),
                          },
                        }),
                        _vm._v(" "),
                        _vm.url
                          ? _c(_vm.tag, {
                              tag: "component",
                              class: { "text-underline": _vm.highlightMode },
                              attrs: {
                                id: _vm.targetIdMap.selection.inquiry.url,
                                href: _vm.url,
                                target: "_blank",
                                rel: "nofollow",
                                "data-test": "url",
                              },
                              domProps: { textContent: _vm._s(_vm.url) },
                            })
                          : _vm._e(),
                        _vm.url
                          ? _c("br", { attrs: { "data-test": "br-url" } })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.zip
                          ? _c("span", {
                              attrs: {
                                id: _vm.targetIdMap.selection.inquiry.zip,
                                "data-test": "zip",
                              },
                              domProps: {
                                textContent: _vm._s("〒 " + _vm.zip),
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.address
                          ? _c("span", {
                              staticClass: "pega-pre-wrap",
                              attrs: {
                                id: _vm.targetIdMap.selection.inquiry.address,
                                "data-test": "address",
                              },
                              domProps: { textContent: _vm._s(_vm.address) },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.zip || _vm.address
                          ? _c("br", { attrs: { "data-test": "br-address" } })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.person
                          ? _c("span", {
                              attrs: {
                                id: _vm.targetIdMap.selection.inquiry.person,
                                "data-test": "person",
                              },
                              domProps: {
                                innerHTML: _vm._s(
                                  "担当者 ／ " + _vm.person + "<br>"
                                ),
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.tel
                          ? _c("span", {
                              attrs: {
                                id: _vm.targetIdMap.selection.inquiry.tel,
                                "data-test": "tel",
                              },
                              domProps: {
                                innerHTML: _vm._s("Tel ／ " + _vm.tel + "<br>"),
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.email
                          ? _c("span", {
                              attrs: {
                                id: _vm.targetIdMap.selection.inquiry.email,
                                "data-test": "email",
                              },
                              domProps: {
                                textContent: _vm._s("E-mail ／ " + _vm.email),
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]
                },
                proxy: true,
              },
            ]),
          },
          _vm.$listeners
        )
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }